import React from "react";
import { IconT } from "types/utils";
import { theme } from "styles/themes/theme";

type ProposalLinkIconProps = IconT & {
  circleFill?: string;
};

export default function ProposalLinkIcon({
  height = "24",
  width = "24",
  fill = theme.colors["darkest-blue"],
  circleFill = theme.colors["athens-gray"],
}: ProposalLinkIconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill={circleFill} />
      <g clipPath="url(#clip0_4032_181)">
        <path
          d="M10.6668 12.667C10.9531 13.0497 11.3184 13.3664 11.7378 13.5956C12.1573 13.8248 12.6211 13.961 13.0979 13.9952C13.5747 14.0293 14.0532 13.9605 14.501 13.7935C14.9489 13.6264 15.3555 13.365 15.6935 13.027L17.6935 11.027C18.3007 10.3983 18.6366 9.55629 18.629 8.6823C18.6215 7.80831 18.2709 6.97227 17.6529 6.35424C17.0348 5.73621 16.1988 5.38565 15.3248 5.37806C14.4508 5.37046 13.6088 5.70644 12.9801 6.31364L11.8335 7.45364M13.3335 11.3336C13.0472 10.9509 12.6819 10.6342 12.2624 10.405C11.843 10.1758 11.3791 10.0396 10.9024 10.0054C10.4256 9.97127 9.94708 10.0401 9.49924 10.2071C9.0514 10.3742 8.64472 10.6356 8.3068 10.9736L6.3068 12.9736C5.69961 13.6023 5.36363 14.4443 5.37122 15.3183C5.37881 16.1923 5.72938 17.0283 6.3474 17.6464C6.96543 18.2644 7.80147 18.615 8.67546 18.6226C9.54945 18.6301 10.3915 18.2942 11.0201 17.687L12.1601 16.547"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4032_181">
          <rect width="16" height="16" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
}
